import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var RightPadPipe = (function () {
    function RightPadPipe() {
    }
    RightPadPipe.prototype.transform = function (str, length, padCharacter) {
        if (length === void 0) { length = 1; }
        if (padCharacter === void 0) { padCharacter = ' '; }
        if (!isString(str) || str.length >= length) {
            return str;
        }
        while (str.length < length) {
            str = str + padCharacter;
        }
        return str;
    };
    RightPadPipe.decorators = [
        { type: Pipe, args: [{ name: 'rpad' },] },
    ];
    /** @nocollapse */
    RightPadPipe.ctorParameters = function () { return []; };
    return RightPadPipe;
}());
export { RightPadPipe };
//# sourceMappingURL=rpad.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/rpad.js
// module id = 285
// module chunks = 4